<template>
  <div class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-slate-100 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 flex items-center justify-center p-4">
    <div class="max-w-lg w-full bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-700 p-8 sm:p-12 text-center relative overflow-hidden">
      <div class="absolute inset-0 bg-gradient-to-br from-slate-50/50 via-transparent to-slate-100/50 dark:from-slate-800/50 dark:via-transparent dark:to-slate-700/50 pointer-events-none"></div>
      
      <div class="relative z-10 flex flex-col items-center">
        <div class="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-blue-500/10 to-indigo-500/10 mb-8 ring-1 ring-slate-900/5 dark:ring-white/10 shadow-sm">
          <Icon icon="tabler:tools" class="w-10 h-10 text-blue-600 dark:text-blue-400" />
        </div>
        
        <h1 class="text-3xl font-bold text-slate-900 dark:text-white tracking-tight mb-4">
          {{ t('maintenance.title') }}
        </h1>
        
        <p class="text-slate-600 dark:text-slate-400 text-lg leading-relaxed mb-8">
          {{ t('maintenance.subtitle') }}
        </p>
        
        <div class="w-full max-w-xs h-1.5 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden mb-8">
            <div class="h-full bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full w-1/3 animate-indeterminate"></div>
        </div>

         <div class="pt-6 border-t border-slate-100 dark:border-slate-800 w-full">
            <p class="text-xs text-slate-400 dark:text-slate-500 font-medium uppercase tracking-wider">
              {{ t('login.defaultAppName', 'AI Agents') }}
            </p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Icon } from "@iconify/vue";
  import { useI18n } from '@/i18n';

  export default {
    name: "maintenance",
    components: {
      Icon,
    },
    setup() {
      const { t } = useI18n();
      return { t };
    }
  };
</script>

<style scoped>
@keyframes indeterminate {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(400%); }
}

.animate-indeterminate {
  animation: indeterminate 1.5s infinite linear;
}
</style>
